import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
// import { Modal } from "bootstrap";
import { Modal } from "react-bootstrap";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";

function OTPview({ stateOTPProps }) {
    const { otpPopup, setOTPPopup, getrowdataDevchallan,setDCPopup,getAllInvoices,setShowbtn } = stateOTPProps;
    const [value, setValue] = useState("");
    const auth = storage.getLocal("user");
    const handleConfirm = async () => {
        let Payload = {
            Invh_id: getrowdataDevchallan.MASK_INVH_ID,
            UserId: auth.UserId,
            Otp:value.toString().trim()
        };
        try {
            let postURL = "DeliveryChallan/ConfirmOTP?";
            //   /api/DeliveryChallan/ConfirmOTP
            let dataresponse = await Axios.get(`${postURL}Invh_id=${encodeURIComponent(Payload.Invh_id)}&UserId=${Payload.UserId}&Otp=${Payload.Otp}`);
            if(dataresponse.data.Status=="Success"){
                toast.success(`${dataresponse.data.Message}`,{
                    position: "top-center",
                    autoClose: 4000,
                });
                setOTPPopup(false);
                setShowbtn(false);
                setValue("");
                setDCPopup(false);
                getAllInvoices();
            }
        } catch (error) {
            console.log();
            toast.error(`${error.response.data.Message}`,{
                position: "top-center",
                autoClose: 4000,
            });
        } finally {
            console.log("hello");
        }
    };
    const handleChange = (e) => {
        const newValue = e.target.value;
        if (/^\d*$/.test(newValue) && newValue.length <= 6) {
            setValue(newValue);  // Set the value if it's a valid positive integer (including zero)
        }
    };
    return (
        <Modal show={otpPopup} className="enterOTP" onHide={() => setOTPPopup(false)} centered  backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="justify-content-start">
                <Modal.Title>Enter OTP</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputText value={value} onChange={handleChange} />
                {/* <InputNumber value={value} onValueChange={(e) => setValue(e.value)} maxLength={5} /> */}
 
            </Modal.Body>
            <Modal.Footer>
                <div className="text-end">
                    <button className="btn btn-primary me-3" onClick={handleConfirm} disabled={value?.toString().trim().length<4}>Confirm</button>
                    <button className="btn btn-cancel-red" onClick={() =>{ setOTPPopup(false); setValue("");}}>Cancel</button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default OTPview;
